
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class PoiPointField extends Vue {
  val: any = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Model('change')
  value!: any;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
